// extracted by mini-css-extract-plugin
export default {"project_name":"PresenterProject_project_name__WmJ4O","project_description":"PresenterProject_project_description__SBzqt","readMe":"PresenterProject_readMe__XS3t1"};